import {
  SERVICE_CATEGORY_ORDER,
  SERVICE_DEFINITIONS,
  type ServiceCategoryLabel,
  type ServiceDefinition,
  type ServiceIcon,
} from "~/content/navigation/serviceCatalog";

export interface Service extends ServiceDefinition {}

export interface ServiceCategory {
  category: ServiceCategoryLabel;
  services: Service[];
}

export type { ServiceCategoryLabel, ServiceIcon };

export const SERVICES: Service[] = SERVICE_DEFINITIONS;

export const CITY_SERVICES = SERVICES.filter((service) => service.cityPages);

export const SERVICES_BY_CATEGORY: ServiceCategory[] = SERVICE_CATEGORY_ORDER.map(
  (category) => ({
    category,
    services: SERVICES.filter((service) => service.category === category),
  })
);

const servicesBySlug = new Map(SERVICES.map((service) => [service.slug, service]));

export function getServiceBySlug(slug: string): Service | undefined {
  return servicesBySlug.get(slug);
}

export function getCityServicePath(citySlug: string, serviceSlug: string): string {
  return `/${serviceSlug}/${citySlug}/`;
}

export function getServiceCategoryByServiceSlug(
  serviceSlug: string
): ServiceCategory | null {
  return (
    SERVICES_BY_CATEGORY.find((category) =>
      category.services.some((service) => service.slug === serviceSlug)
    ) ?? null
  );
}

export function getRelatedServices(serviceSlug: string): Service[] {
  const category = getServiceCategoryByServiceSlug(serviceSlug);
  if (!category) {
    return [];
  }

  return category.services.filter((service) => service.slug !== serviceSlug);
}
